import { createSelector } from 'reselect'

import type { Customer, CustomerBugsnagData, User, UserBugsnagData } from '../models/store/Customer'

const user = (s: any): User => s.app.user
const customer = (s: any): Customer => s.app.customer

const getUserData = createSelector(user, (user: User): UserBugsnagData | null => {
  if (!user?.id) return null
  const { createdAt, id, role } = user

  return {
    'User ID': id,
    'Created at': createdAt,
    Role: role?.name,
  }
})

const getCustomerData = createSelector(customer, (customer: Customer): CustomerBugsnagData | null => {
  if (!customer?.id) return null
  const { id, clientId, createdAt, planName, codeStatusId, isPartner, isMaster, isSubAccount } = customer

  return {
    ID: id,
    'Client ID': clientId,
    'Created at': createdAt,
    Plan: planName,
    'Code Status': codeStatusId,
    Partner: isPartner,
    Master: isMaster,
    'Sub Account': isSubAccount,
  }
})

export const getBugsnagData = createSelector(
  [getUserData, getCustomerData],
  (user: UserBugsnagData | null, customer: CustomerBugsnagData | null) => ({ user, customer }),
)
